import styled from "styled-components";

interface StyledDiamondProps {
  color: "primary" | "secondary";
}

export default styled.div<StyledDiamondProps>`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ color }) =>
    color === "secondary" ? "#a6b30a" : "#1a5690"};
  transform: rotate(45deg);
`;
